import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps3/weka'
});
export default {
	init() {
		return httpClient.get('/init');
	},
	getCaptcha() {
		return httpClient.get('/captcha');
	},
	sendData(params, file) {
		const formData = new FormData();
		const requestJson = JSON.stringify(params);
		const requestBlob = new Blob([requestJson], {
			type: 'application/json'
		});
		file && formData.append('file', file);
		formData.append('request', requestBlob);
		return httpClient.post('/sendData', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
	}
};
